<template>
  <section class="py-10 md:py-16 text-center relative overflow-hidden">
    <div class="bg-white/80  backdrop-blur-sm rounded-xl p-8 md:p-12 shadow-lg max-w-4xl mx-auto relative z-10">
      <Motion
        :initial="{ opacity: 0, y: 30 }"
        :whileInView="{ opacity: 1, y: 0 }"
        :transition="{ duration: 0.7 }"
        :viewport="{ once: true }"
      >
        <h2 class="text-3xl md:text-4xl font-bold mb-4 text-slate-800 ">
          Ready to Make <Text3d class="inline-block text-yellow-500 " animate>Waves</Text3d>?
        </h2>
        <p class="text-lg text-gray-700  mb-8 max-w-2xl mx-auto">
          Join the thousands of cruise-goers who have made unforgettable memories with DuckNSeek. Get started today!
        </p>
      </Motion>
      
      <Motion
        :initial="{ opacity: 0, y: 20 }"
        :whileInView="{ opacity: 1, y: 0 }"
        :transition="{ duration: 0.7, delay: 0.2 }"
        :viewport="{ once: true }"
        class="flex flex-wrap justify-center gap-4"
      >
        <ShimmerButton
          @click="$emit('scroll-to', 'pricing')" 
          shimmer-color="rgba(255, 255, 255, 0.8)"
          background="#eab308"
          class="px-8 py-2.5 font-medium inline-flex items-center gap-2 text-white"
          to="/#pricing"
        >
          <v-icon class="mr-2">mdi-duck</v-icon>
          Get Started
        </ShimmerButton>
        
        <v-btn
          variant="outlined"
          size="x-large"
          prepend-icon="mdi-message"
          to="/contact"
          color="yellow"
          class="px-8 contact-us-btn"
        >
          Contact Us
        </v-btn>
      </Motion>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Motion } from 'motion-v';
import { Text3d } from '@/components/ui/text3d';
import { ShimmerButton } from '@/components/ui/shimmerButton';
</script>

<style scoped>
/* Style for consistent outline and text color */
.contact-us-btn {
  border-color: #eab308 !important;
  color: #eab308 !important;
}

:deep(.contact-us-btn .v-btn__content) {
  color: #eab308 !important;
}

:deep(.contact-us-btn .v-icon) {
  color: #eab308 !important;
}

/* Match hover effect with the other button */
.contact-us-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(234, 179, 8, 0.2);
  transition: all 0.2s ease;
}
</style>
